import { render, staticRenderFns } from "./PriorityComponent.vue?vue&type=template&id=f7cea6b8"
import script from "./PriorityComponent.vue?vue&type=script&lang=ts"
export * from "./PriorityComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports